import React from "react"
import {useStaticQuery, graphql} from "gatsby"
import Img from 'gatsby-image'

function Rentals({data}) {

  const {area_name, area_name_full} = data

  const images = useStaticQuery(graphql`
    query {
        twoWayRadios: file(relativePath: {eq: "commusa-two-way-radios.jpg"}) {
            childImageSharp {
                fluid {
                    ...GatsbyImageSharpFluid
                }
            }
        }
    }
  `)

  return (
    <div className="container py-3" id="rentals">
      <div className="row">
        <div className="col-12 col-lg-6 pb-5 pt-3 pt-lg-5">
          <h2>Two-Way Radio Rentals in {area_name}</h2>
          <p>So, you have a big event or project coming up, but your current communication system isn’t up to the job.
            Or, you want to try out our two-way radios before making a permanent investment. It sounds like you need a
            rental from CommUSA.</p>
          <p>We have the most extensive inventory of all the rental two-way radios in {area_name_full}, including
            portables, repeaters, base stations, and accessories. No matter how big or how small, CommUSA rentals can
            help make your upcoming event or project a major success.</p>
          <div className="btn-group" role="group">
            <a className="btn btn-primary mr-1" role="button" href="tel:1-800-338-1949"><i
              className="fas fa-phone-alt mr-1"> </i>800.338.1949</a><a className="btn btn-info ml-1" role="button"
                                                                       href="https://www.commusa.com/contact-us">Request
            Quote</a>
          </div>
        </div>
        <div
          className="col-12 col-lg-6 d-flex flex-column justify-content-center order-first order-lg-last px-0 px-lg-3 py-0">
          <Img className="w-100 mb-3" fluid={images.twoWayRadios.childImageSharp.fluid}
               alt="CommUSA - Two-Way Radio Rentals"/></div>
      </div>
      <div className="row">
        <div className="col-12 mt-3">
          <h5>Here’s how the CommUSA rental process works:</h5>
          <p>Our client services experts will help you decide on the number and type of two-way radios and accessories
            you’ll need. Once you and your representative design a communication strategy that’s perfect for your needs,
            we’ll create an agreement that optimizes connectivity at a competitive price.</p>
          <p>Next, we program your two-way radios (included in the price) and ship them to you, no matter where you’re
            located. Have a question about your two-way radio order? Don’t worry— we won’t leave you hanging once we
            fulfill your order. We offer full support throughout the entire rental process.</p>
          <p>If you’re concerned about damaging your two-way radios, CommUSA offers renters insurance at an extra cost.
            This will protect you from paying full price for a two-way radio or accessory that’s broken or damaged
            during the rental period.</p>
          <p>Next time you’re searching for two-way radio and accessory rentals in {area_name_full}, you need to check out
            CommUSA’s high-quality two-way radios. Here are just a couple of our most frequently rented two-way
            radios.</p>
          <ul>
            <li>
              <strong>Motorola CP200d</strong><br/>
              The Motorola CP200d is our top-selling rental model in {area_name_full} for a reason. With both digital and
              analog versions of this compact and highly durable model available, the CP200d is the best option for
              renters on a budget.
            </li>
            <li>
              <strong>XPR7550e</strong><br/>
              For some projects, budget-friendly models just aren’t enough. You need a high-end two-way radio like the
              XPR7550e.
            </li>
          </ul>
          <p>From a colored digital screen to work order ticketing functionality, the XPR7550e has everything your
            workers need. Up to twenty-nine hours of battery life and up to 8% extended range for dead spots, enhanced
            audio quality for noisy environments, and superior waterproofing for whatever your project throws its
            way.</p>
          <p>Since we only work with Motorola products, you’re getting a high-value product no matter which radio you
            choose. Plus, the extended battery life and many intrinsically safe options mean our two-way radio and
            accessory rentals are perfect for oil and gas turnarounds, big events, sporting games and tournaments,
            conferences, concerts, trade shows, festivals, and so much more!</p>
          <p>If you need a two-way radio rental in {area_name_full}, get in touch with CommUSA today to find out how we can
            make your project a huge success.</p>
          <div className="btn-group" role="group">
            <a className="btn btn-primary mr-1" role="button" href="tel:1-800-338-1949"><i
              className="fas fa-phone-alt mr-1"> </i>800.338.1949</a><a className="btn btn-info ml-1" role="button"
                                                                       href="https://www.commusa.com/contact-us">Request
            Quote</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Rentals
